import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { CreateEventFormStore } from '../../_services/create-event-form-store.service';
import { StreappEventsService } from 'src/app/services/streapp-events.service';
import { EventType, EventTypeMain } from '../../../_models/eventtype.model';

@Component({
  selector: 'category-selection-step',
  standalone: false,
  templateUrl: './category-selection-step.component.html',
  styleUrl: './category-selection-step.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class CategorySelectionStepComponent {
  public eventFormStore = inject(CreateEventFormStore);

  public linkedEvent = computed(() => !!this.eventFormStore.streappEvent().linkedToMainStreappID);

  public streappService = inject(StreappEventsService);

  public selectedEvent = signal<EventTypeMain | null>(null);

  public selectedSubEvent = signal<EventType | null>(null);

  public constructor() {
    var category = this.eventFormStore.streappEvent().category || null;
    var subCategory = this.eventFormStore.streappEvent().subcategory || null;
    this.selectedEvent.set(category);
    this.selectedSubEvent.set(subCategory);
    
    var valid = category !== null && subCategory !== null;
    this.eventFormStore.stepCategoryValid.set(valid);
  }

  public selectEventType(eventType: EventTypeMain): void {
    this.selectedEvent.set(eventType);
    this.eventFormStore.stepCategoryValid.set(true);
    if (this.selectedSubEvent() && !this.selectedEvent()?.children?.find(child => child === this.selectedSubEvent())) {
      this.selectedSubEvent.set(null);
      this.eventFormStore.updateCategories(this.selectedEvent()!, this.selectedSubEvent()!);
      this.eventFormStore.stepCategoryValid.set(false);
    }
  }

  public selectSubEventType(eventType: EventType): void {
    this.selectedSubEvent.set(eventType);
    this.eventFormStore.updateCategories(this.selectedEvent()!, this.selectedSubEvent()!);
    this.eventFormStore.stepCategoryValid.set(true);
    this.eventFormStore.setStep(this.eventFormStore.currentStep() + 1);
  }
}
